module.exports = __webpack_public_path__ + "media/images/flags/64/Vietnam-17d7ac9dca7522b4ec780658e75c9cb0.png";